import React from 'react';
import Text from '@bufferapp/ui/Text';
import Button from '@bufferapp/ui/Button';
import { useAppSelector } from '~/store';
import { selectCurrentOrganizationId } from '~/organizations/selectors';
import { BufferTracker } from '@bufferapp/buffer-tracking-browser-ts';
import useDismissBanner, {
  BannerTypes,
} from '~/profile-page/hooks/useDismissBanner';
import { useDismissedBanners } from '~/accountContext';
import {
  Layout,
  Container,
  ButtonsContainer,
  FirstButtonContainer,
} from './styles';

export const MastodonChannelsPromoBanner = () => {
  const organizationId = useAppSelector((state) =>
    selectCurrentOrganizationId(state)
  );

  const dismissedBanners = useDismissedBanners();
  const showBanner =
    dismissedBanners && !dismissedBanners.includes('mastodonChannelPromo');

  const { onDismissBanner } = useDismissBanner({
    banner: BannerTypes.mastodonChannelPromo,
  });

  const onDismissClicked = () => {
    BufferTracker.mastodonChannelPromoDismissed({
      organizationId,
      clientName: 'publishWeb',
      product: 'publish',
    });
    onDismissBanner();
  };

  if (!showBanner) return <></>;

  return (
    <Layout
      dismiss={() => {
        onDismissClicked();
      }}
      type="note"
      disableAnimation
    >
      <Container>
        <img
          src="https://buffer-publish.s3.amazonaws.com/images/buffer_x_mastodon_badge.svg"
          alt="Buffer x Mastodon"
          height={24}
        />
        <Text type="h3">Mastodon is now available in Buffer</Text>
        <Text type="p">
          Learn more about the fastest growing social network and how to make it
          work for you.
        </Text>
        <ButtonsContainer>
          <FirstButtonContainer>
            <Button
              type="primary"
              size="small"
              label="Connect Mastodon"
              onClick={() => {
                window.location.assign(
                  'https://account.buffer.com/channels/connect?cta=publish-twitterProfile-mastodonBanner-connectChannel-1'
                );
              }}
            />
          </FirstButtonContainer>
          <Button
            type="secondary"
            size="small"
            label="Read our Beginner’s Guide"
            onClick={() => {
              window.open(
                'https://buffer.com/resources/mastodon-social/?utm_source=bufferweb&utm_campaign=mastodon-launch',
                '_blank'
              );
            }}
          />
        </ButtonsContainer>
      </Container>
      <img
        src="https://buffer-publish.s3.amazonaws.com/images/mastodon-promo-banner-image.png"
        alt="Mastodon Promo Banner"
        width={358}
      />
    </Layout>
  );
};

MastodonChannelsPromoBanner.propTypes = {};
